import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

/**
 * Editorial "Start a post" pill. Shared between the Home posts toolbar and
 * the BandPage Announcements toolbar so both surfaces stay visually identical
 * and any future styling tweaks ship in one place.
 */
export default function StartPostButton({
  label = 'Start a post',
  onClick,
  disabled = false,
  className = '',
  ariaLabel,
  icon = '+',
}) {
  return (
    <button
      type="button"
      className={classNames('start-post-btn', className)}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || (typeof label === 'string' ? label : undefined)}
    >
      {icon ? <span className="start-post-btn__plus" aria-hidden="true">{icon}</span> : null}
      <span className="start-post-btn__label">{label}</span>
    </button>
  );
}

StartPostButton.propTypes = {
  label: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  icon: PropTypes.node,
};
